<div id="record-locator-loading-page" class="flex flex-1 min-h-0 flex-col">
  <div
    *ngIf="loadingTefcaRLS"
    class="flex flex-1 flex-col items-center text-center mt-fdk-xxxl"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <div class="record-locator-messages">
      @for (index of visibleMessageIndices; track index) {
        <div
          class="record-locator-message flex flex-col items-center"
          [class.record-locator-message--outgoing]="index === previousMessageIndex"
          [class.record-locator-message--incoming]="previousMessageIndex !== null && index === currentMessageIndex"
          [attr.aria-hidden]="index === previousMessageIndex ? 'true' : null"
        >
          <div class="record-locator-illustration">
            <fdk-illustration [name]="loadingMessages[index].illustration" />
          </div>
          <fdk-loading-dots class="mt-fdk-s" />
          <h2 class="fdk-type-heading-2 text-fdk-primary mt-fdk-l">
            {{ loadingMessages[index].title }}
          </h2>
          <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
            {{ loadingMessages[index].description }}
          </p>
        </div>
      }
    </div>
  </div>
</div>
